import { MuiThemeProvider } from '@material-ui/core';
import React from 'react';
import { PatientSlot } from '@/components/pages/kiosk/PACUv2/index';
import { usePacuV2State } from '@/components/pages/kiosk/PACUv2/PacuV2State';
import { useMutation } from '@apollo/client';
import { assignBedInRoom } from '@/graph/patients';
import { muiThemeDark, muiThemeLight } from '@/muiTheme';

interface BedSlotProps {
  bedNumber?: number | string;
  patientId: any;
  patientName: string;
  pacuNurse?: any;
  surgeonName: string;
  procedure?: string;
  isAssigned: boolean;
  onClick?: () => void;
  onAssignNurse?: (patientId: any, roomId: any) => void;
  onAssigned?: (patientId: any, roomId: any) => void;
  roomId: any;
  inside: boolean;
  room: any;
  timeEntered?: Date;
  transferredToChair?: Date;
  transferredToPT?: Date;
  ptComplete?: Date;
}

const BedSlot = ({
  bedNumber,
  patientId,
  patientName,
  pacuNurse,
  surgeonName,
  procedure,
  isAssigned,
  onClick,
  onAssignNurse,
  onAssigned,
  roomId,
  inside,
  room,
  timeEntered,
  transferredToChair,
  transferredToPT,
  ptComplete,
}: BedSlotProps) => {
  const [state, setState] = usePacuV2State();
  const assign = state?.type == 'AssignBed';

  const [assignBedMutation, { loading }] = useMutation(assignBedInRoom);

  const handleAssignBed = async (e: MouseEvent) => {
    e.stopPropagation();

    try {
      setState({ type: 'Idle' });

      await assignBedMutation({
        variables: {
          // @ts-ignore
          id: state?.patientId,
          bed: String(bedNumber),
          roomId,
        },
      });
      // @ts-ignore
      onAssigned?.(state?.patientId, roomId);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <MuiThemeProvider theme={inside ? muiThemeLight : muiThemeDark}>
      <PatientSlot
        bedNumber={bedNumber}
        patientName={patientName}
        pacuNurse={pacuNurse}
        surgeonName={surgeonName}
        procedure={procedure}
        onAssignNurse={() => onAssignNurse?.(patientId, roomId)}
        isAssigned={isAssigned}
        inside={inside}
        isAssigning={assign}
        onClick={isAssigned ? onClick : ((loading ? undefined : assign ? handleAssignBed : onClick) as any)}
        room={room}
        timeEntered={timeEntered}
        transferredToChair={transferredToChair}
        transferredToPT={transferredToPT}
        ptComplete={ptComplete}
      />
    </MuiThemeProvider>
  );
};

export default BedSlot;
